/**
 * Auth0 SPA configuration, read at runtime via `src/lib/runtimeConfig.js` so one compiled bundle
 * serves every environment (see that module for why). Locally, the `REACT_APP_AUTH0_*` fallbacks
 * still apply: `make build` fills them from `AUTH0_ISSUER` (domain only),
 * `AUTH0_CLIENT_ID` and `AUTH0_AUDIENCE` when the REACT_APP_ names are unset (see repo root
 * `.env.example`).
 *
 * `@auth0/auth0-react` expects `domain` = hostname only (e.g. `dev-tenant.us.auth0.com`). Full issuer URLs
 * or stray quotes in `.env` produce broken authorize URLs (`https://https://…` or `https://"https/…`).
 */
import { getConfig } from "../lib/runtimeConfig";
function normalizeAuth0Domain(raw) {
  let d = String(raw || "").trim();
  if (
    (d.startsWith('"') && d.endsWith('"')) ||
    (d.startsWith("'") && d.endsWith("'"))
  ) {
    d = d.slice(1, -1).trim();
  }
  d = d.replace(/^https:\/\//i, "").replace(/^http:\/\//i, "");
  d = d.split("/")[0].split("?")[0];
  return d.trim();
}

const auth0ClientConfig = {
  domain: normalizeAuth0Domain(getConfig("AUTH0_DOMAIN")),
  clientId: getConfig("AUTH0_CLIENT_ID"),
  audience: getConfig("AUTH0_AUDIENCE"),
};

export default auth0ClientConfig;
